module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showGitMerged) ? _c('div', {
    staticClass: "section-title"
  }, [_vm._v("\n    Ostatnie ukończone zadania\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gitlabSummary.latest_merged), function(item, index) {
    return [_c('table', {
      staticClass: "table table-gitlab"
    }, [_c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Tytuł")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Czas utworzenia")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getConvertedDate(item.created_at)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Czas aktualizacji")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getConvertedDate(item.updated_at)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Zatwierdzone przez")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.merged_by.name))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Link")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.web_url
      }
    }, [_vm._v("Przejdź")])])])]), _vm._v(" "), (index !== _vm.gitlabSummary.latest_merged.length - 1) ? _c('div', {
      staticClass: "divider"
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.showGitEvents) ? _c('div', {
    staticClass: "section-title"
  }, [_vm._v("\n    Ostatnie wykonane akcje\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gitlabSummary.latest_events), function(item, index) {
    return [_c('table', {
      staticClass: "table table-gitlab"
    }, [_c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Akcja")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.action_name))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Czas")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getConvertedDate(item.created_at)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Typ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getEventType(item)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Tytuł")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getEventTitle(item)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "col1"
    }, [_vm._v("Cel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getEventRef(item)))])])]), _vm._v(" "), (index !== _vm.gitlabSummary.latest_events.length - 1) ? _c('div', {
      staticClass: "divider"
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61e32c0a!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/EmployeeGitStatus.vue
// module id = 1098
// module chunks = 0